import React, {ReactElement} from 'react';
import {
  StyledSwitch,
  StyledSwitchContainer,
  StyledSwitchWrapper,
  StyledSwitchTitleContainer,
} from './styles';
import Props from './typings';

const Switch = ({
  title,
  subtitle,
  checked,
  onLabel,
  offLabel,
  disabled = false,
  callback,
}: Props): ReactElement => {
  return (
    <StyledSwitchContainer>
      {title && (
        <StyledSwitchTitleContainer>
          <h4>{title}</h4>

          {subtitle && <p>{subtitle}</p>}
        </StyledSwitchTitleContainer>
      )}

      <StyledSwitchWrapper>
        <StyledSwitch $disabled={disabled}>
          <input
            type="checkbox"
            checked={!!checked}
            onChange={(e) => callback(e.target.checked)}
            aria-disabled={disabled}
          />

          <span></span>
        </StyledSwitch>

        {onLabel && <span>{checked ? onLabel : offLabel}</span>}
      </StyledSwitchWrapper>
    </StyledSwitchContainer>
  );
};

export default Switch;
